import { render, staticRenderFns } from "./OnboardingGender.vue?vue&type=template&id=21b1c6e9&scoped=true&"
import script from "./OnboardingGender.vue?vue&type=script&lang=js&"
export * from "./OnboardingGender.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingGender.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OnboardingGender.vue?vue&type=style&index=1&id=21b1c6e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1c6e9",
  null
  
)

export default component.exports